import request from '../request';

// 获取行业列表
export function getIndustryList() {
    return request('/industry/getIndustryList', {
        method: 'GET'
    });
}

// 获取省份
export function getProvinceList() {
    return request('/area/getProvinceList', {
        method: 'GET'
    });
}

// 获取市
export function getCityList(params) {
    return request('/area/getCityList', {
        method: 'GET',
        params
    });
}
// 获取OSS配置
export function getOSSConfig() {
    return request('/oss/sign', {
        method: 'POST'
    });
}
/**
 * 获取banner图
 * @param {*} type 
 * @returns 
 */
export function getBannerURL(type) {
    return request(`/banner/getCommunityBanners/${type}`);
}
/**
 * 获取合作伙伴列表
 */
export function getPartnerList() {
    return request(`/link/list`);
}
